import { useTranslations } from "next-intl";
import { useSizeReferenceDisplay } from "@hooks/use-current-user";
import Link from "@components/core/Link";
import SizeReferenceMention from "@components/core/SizeReferenceMention";
import ProductImage from "@components/core/ProductImage";
import closetStates from "@utils/constants/closetStates";
import translateVariantSize from "@utils/translateVariantSize";
import sizeTypes from "@utils/constants/sizeTypes";
import ProductPrice from "./ProductPrice";
import ClosetItemButtons from "./ClosetItemButtons";

function ClosetItem({ closetState, closetItem, closetHasMailboxPickingRequested }) {
  const t = useTranslations("common");

  const sizeReference = useSizeReferenceDisplay();

  const product = closetItem?.product || {};

  return (
    <div className="closet-items-list-card-container">
      <div className="closet-items-list-card-content">
        <div className="picture-section bg-light">
          <Link
            href={`/products/${product.slug}`}
            className="w-100"
          >
            <ProductImage
              src={product.main_picture_url}
              alt={product.name}
              className="closet-items-list-card-image"
              sizes="192px"
            />
          </Link>
        </div>

        <div className="description-section">
          <div className="d-flex flex-column gap-1 mb-2 w-100">
            <h6 className="mb-0 drawer-closet-item-name">{product.name}</h6>

            <p className="mb-0 font-size-sm text-gray drawer-closet-item-name">
              {product.brand.name}
            </p>

            <p className="mb-0 font-size-sm text-gray">
              {t("variant_size", {
                size: translateVariantSize(
                  closetItem.variant.size?.type,
                  closetItem.variant.size?.value,
                  t,
                  sizeReference,
                ),
              })}
              {closetItem.variant.size?.type === sizeTypes.size_fr && <SizeReferenceMention />}
            </p>
          </div>

          {closetState === closetStates.received &&
            !closetHasMailboxPickingRequested &&
            !closetItem.purchased &&
            !closetItem.purchasing && <ProductPrice product={product} />}
          {closetItem.purchased && (
            <p className="mb-0 font-size-sm text-gray">{t("drawer.card.bought")}</p>
          )}
          {closetItem.purchasing && (
            <p className="mb-0 font-size-sm text-gray">{t("drawer.card.purchasing")}</p>
          )}
        </div>
      </div>

      <ClosetItemButtons
        closetState={closetState}
        closetItem={closetItem}
        closetHasMailboxPickingRequested={closetHasMailboxPickingRequested}
      />
    </div>
  );
}

export default ClosetItem;
